<template>
    <div class="ba6-elearning-card">
        <builderall-loader :loading="showLoading">
            <div v-if="view.routes.upgrade_elearning == null && hasResponse" class="ba6-card">
                <div class="ba6-top">
                    <a :href="view.routes.elearning" class="ba6-title">{{ t.checkout_title_plan_elearning_starter_toolannual_brl }}</a>
                </div>
                <hr class="ba6-card-line">
                <div class="ba6-main-elearning">
                    <div class="ba6-e-statistics">
                        <div v-for="s,i in elearningData.statistic" :key="i" class="ba6-e-statistic">
                            <span class="ba6-e-title" v-text="getTitle(i)"></span>
                            <span class="ba6-e-count" v-text="s"></span>
                        </div>
                    </div>
                    <div class="ba6-table">
                        <div class="ba6-gray-box">
                            <span>{{ t.label_course_name }}</span>
                            <span>{{ decodeString(t.registered_students) }}</span>
                        </div>
                        <div class='ba6-list'>
                            <a v-for="d,i in elearningData.courses" :key="i" :href="d.url" target="_blank" class="ba6-link">
                                <span class="ba6-bold" v-text="d.name"></span>
                                <hr>
                                <span class="ba6-count" v-text="d.students_count"></span>
                            </a>
                        </div>
                    </div>
                </div>
                <a v-if="hasResponse" :href="view.routes.elearning" class="ba6-view-all" v-text="t.view_all_notifications"></a>
            </div>
            <div v-else class="ba6-card empty-data">
                <div class="image-content">
                    <img src="https://cheetah.builderall.com/franquias/2/7291108/editor-html/12797260.png">
                </div>
                <div class="empty-content">
                    <builderall-icon class="tool-icon" code='elearning'></builderall-icon>
                    <h4 v-text="t.new_e_learning"></h4>
                    <p v-text="decodeString(t.elearning_card_description)"></p>
                    <a 
                        class="ba-btn ba-blue ba-md"
                        :href="view.routes.upgrade_elearning != null ? view.routes.upgrade_elearning : view.routes.elearning"
                    >
                        {{ t.label_create_a_course }}
                        <builderall-icon code='arrow-right'></builderall-icon>
                    </a>
                </div>
            </div>
        </builderall-loader>
    </div>
</template>

<script>
    export default {
        name: "ba6-elearning-card",
        props: ['view'],
        data() {
            return {
                elearningData: [],
                showLoading: false,
                t: null,
                hasResponse: false
            }
        },
        created(){
            this.t = this.view.translations
            if(this.view.routes.upgrade_elearning == null){
                this.getElearningStatistics();
            }
        },
        methods: {
            getTitle(slug){
                const keys = [
                    {slug: 'courses_count',     t: this.t.menu_courses},
                    {slug: 'students_count',    t: this.t.students},
                    {slug: 'instructors_count', t: this.t.instructors},
                ]
                
                return keys.find(x => x.slug == slug).t
            },
            getElearningStatistics(){
                this.showLoading = true;
                const headers = {
                    Accept: 'application/json',
                    Authorization: this.view.token
                };

                fetch(this.view.routes.orchestrator+'/api/v1/office/dashboard-data/elearning', {
                    method: 'GET',
                    headers: headers
                })
                    .then(response => response.json())
                    .then(result => {
                        if(result.data.user_exists_in_tool == undefined && Object.keys(result.data).length > 0){
                            this.elearningData = result.data;
                            this.hasResponse = true;
                        }
                    })
                    .catch(error => {
                        console.log('getElearningStatistics data error', error);
                    })
                    .finally(f => this.showLoading = false)
            },
            decodeString(string) {
              return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent;
            },
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/elearning/ElearningCard.vue